// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const magikarp: PokeData = {
  "id": 129,
  "name": "magikarp",
  "height": 9,
  "weight": 100,
  "base_experience": 40,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "tackle",
    "splash",
    "flail"
  ],
  "moves": [
    "tackle",
    "splash",
    "aqua-cutter",
    "hydro-pump",
    "liquidation",
    "rain-dance",
    "whirlpool",
    "water-spout",
    "bubble-beam",
    "aqua-jet",
    "bubble",
    "life-dew",
    "brine"
  ],
  "evolution_chain": {
    "id": 64,
    "item": null,
    "species": [
      {
        "name": "magikarp",
        "order": 153,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gyarados",
        "order": 154,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 129,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 28.75,
    "speed": 80,
    "ability_power": 15
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
